import type { StyledComponent } from '@emotion/styled';
import { Chip, styled } from '@mui/material';
import { customColorPalette } from '@orcha/micro-library-core-ui';

export const CategoryTag: StyledComponent<any> = styled(Chip)({
  borderRadius: '4px',
  backgroundColor: customColorPalette.blueGreyLight,
  '& .MuiChip-label': {
    paddingLeft: '13px',
    paddingRight: '13px',
    paddingTop: '4px',
    paddingBottom: '4px',
    fontWeight: 500,
    lineHeight: '1.375rem',
    fontSize: '0.75rem',
    letterSpacing: '0.34px',
  },
});

export const LeadCategoryTag: StyledComponent<any> = styled(CategoryTag)(
  ({ theme }) => ({
    backgroundColor: customColorPalette.blueGreyDark,
    color: theme.palette.common.white,
  })
);
